(function ($, Drupal, drupalSettings) {
  "use strict";

  // Homepage Partners
  // var swiper = new Swiper(".swiper-logos", {
  //   slidesPerView: "auto",
  //   centeredSlides: true,
  //   spaceBetween: 30,
  //   loop: true,
  //   autoplay: {
  //     delay: 2500,
  //     disableOnInteraction: false,
  //   },
  // });

  Drupal.behaviors.accountForm = {
    attach: function (context, settings) {

      $(once('bind-click-event', '.open-login'))
        .on("click", function () {
          $(".account-form").toggleClass("open");
          $("body").removeClass("mobile-menu-open");
        });
    },
  };

  Drupal.behaviors.RegisterForm = {
    attach: function (context, settings) {
      $("#edit-mail, #edit-field-phone-0-value").attr('autocomplete', 'off');
    },
  };

  Drupal.behaviors.dashboardFacets = {
    attach: function (context, settings) {
      $(once('facets-open', ".dashboard .region-facets .block-facets h3",context))
        .on("click", function () {
          $(this).parents(".block-facets").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.dashboardExposedFilters = {
    attach: function (context, settings) {
        var blockSelector = ".region-facets .block-views-exposed-filter-blocksearch-job-page-1";
        $(once('exposed_filter-open', blockSelector + " .fieldset-legend",context))
        .on(
          "click",
          function () {
            $(this).parents("fieldset").toggleClass("open");
          }
        );
        // Close the fieldset when the user clicks anywhere outside of it.
        $(once('exposed_filter-outside', 'body')).on("click", function (e) {
          if (!$(e.target).closest(blockSelector + " fieldset").length) {
            $(blockSelector + " fieldset").removeClass("open");
          }
        });
    },
  };

    Drupal.behaviors.dashboardExposedFiltersTraining = {
    attach: function (context, settings) {
        var blockSelector = " .region-facets .block-views-exposed-filter-blocksearch-training-page-1";
        $(once('exposed_filter-open', blockSelector + " .fieldset-legend",context))
        .on(
          "click",
          function () {
            $(this).parents("fieldset").toggleClass("open");
          }
        );
        // Close the fieldset when the user clicks anywhere outside of it.
        $(once('exposed_filter_training-outside', 'body')).on("click", function (e) {
          if (!$(e.target).closest(blockSelector + " fieldset").length) {
            $(blockSelector + " fieldset").removeClass("open");
          }
        });
    },
  };

  Drupal.behaviors.jobDetails = {
    attach: function (context, settings) {
        $(once('job-details-open', ".group-details-wrapper .sublabel"))
        .on("click", function () {
          $(this).parent(".group-details-wrapper").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.candidatesList = {
    attach: function (context, settings) {
        $(once('candidates-list-open', ".candidates-list-wrapper .candidates-list-header"))
        .on("click", function () {
          $(this).parent(".candidates-list-wrapper").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.CandidateEditFieldsetDetails = {
    attach: function (context, settings) {
      // $(".node-candidate-profile fieldset#personal-info").addClass("open");
        $(once('candidate-profile-fieldset-open', ".node-candidate-profile fieldset legend"))
        .on("click", function () {
          $(this).parent("fieldset").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.CandidateCreateFieldsetDetails = {
    attach: function (context, settings) {
      $(".node-candidate-profile-form fieldset#personal-info").addClass("open");
        $(once('add-candidate-profile-fieldset-open', ".node-candidate-profile-form fieldset legend"))
        .on("click", function () {
          $(this).parent("fieldset").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.JobSearchTabs = {
    attach: function (context, settings) {
      $(".tab-save-search").on("click", function () {
        $(this).addClass("active");
        $(this).siblings(".active").removeClass("active");
        $(".block-search-api-saved-searches").show();
        $(".region-facets,.region-content").hide();
      });
      $(".tab-filters").on("click", function () {
        $(this).addClass("active");
        $(this).siblings(".active").removeClass("active");
        $(".block-search-api-saved-searches").hide();
        $(".region-facets,.region-content").show();
      });
      $(".search_notifications_link").on("click", function () {
        $(".tab-save-search").addClass("active");
        $(".tab-filters").removeClass("active");
        $(".block-search-api-saved-searches").show();
        $(".region-facets,.region-content").hide();
      });
      // $(".info").on("click", function () {
      //   introJs().start();
      // });
    },
  };

  Drupal.behaviors.LanguageSwitcher = {
    attach: function (context, settings) {
        $(once('language-switcher-open', ".language-switcher-wrapper"))
        .on("click", function () {
          $(this).toggleClass("open");
        });
    },
  };

  Drupal.behaviors.MobileMenu = {
    attach: function (context, settings) {
      if ($(window).width() < 769) {
          $(once('burger-open', ".burger"))
          .on("click", function () {
            $("body").toggleClass("mobile-menu-open");
            $(".account-form").removeClass("open");
          });
          $(once('menu-item-expanded', ".menu-item--expanded > span"))
          .on("click", function () {
            $(this).parents(".menu-item--expanded").toggleClass("expand");
          });
      }
    },
  };

  Drupal.behaviors.ConditionalFields = {
    attach: function (context, settings) {
      // $(".field--name-field-identity-document")
      //   .on("change loadtime", function () {
      //     if ($(this).find("input:checked").val() == 1) {
      //       $(
      //         ".field--name-field-identity-document-type, .field--name-field-id-expiration-date"
      //       ).addClass("open");
      //     } else {
      //       $(
      //         ".field--name-field-identity-document-type, .field--name-field-id-expiration-date"
      //       )
      //         .removeClass("open")
      //         .find("select")
      //         .prop("selectedIndex", 0);
      //     }
      //   })
      //   .triggerHandler("loadtime");

      $(".field--name-field-identity-document-type")
        .on("change loadtime", function () {
          if ($(this).find("select option:selected").val() == "cypriot_citizen_id") {
            $(".field--name-field-issuance-pending").addClass("open");
            $(".field--name-field-id-expiration-date").addClass("open");
            $(".field--name-field-residence-permit-exp-date").removeClass("open");
            $(".field--name-field-issuance-date-recognition").removeClass("open");
          } else if ($(this).find("select option:selected").val() == "residence_permit") {
            $(".field--name-field-issuance-pending").addClass("open");
            $(".field--name-field-id-expiration-date").removeClass("open");
            $(".field--name-field-residence-permit-exp-date").addClass("open");
            $(".field--name-field-issuance-date-recognition").removeClass("open");
          } else if ($(this).find("select option:selected").val() == "decision_letter_by_asylum_authorities") {
            $(".field--name-field-issuance-pending").removeClass("open");
            $(".field--name-field-id-expiration-date").removeClass("open");
            $(".field--name-field-residence-permit-exp-date").removeClass("open");
            $(".field--name-field-issuance-date-recognition").addClass("open");
          } else {
            $(".field--name-field-issuance-pending").removeClass("open");
            $(".field--name-field-id-expiration-date").removeClass("open");
            $(".field--name-field-residence-permit-exp-date").removeClass("open");
            $(".field--name-field-issuance-date-recognition").removeClass("open");
          }
        })
        .triggerHandler("loadtime");

      $(".field--name-field-job-permanent-position")
        .on("change loadtime", function () {
          if ($(this).find("input:checkbox:checked").length) {
            $("#edit-group-duration-work")
              .hide()
              .find("input:text, input[type='date'], input[type='number'], textarea")
              .val("")
              .end()
              .find("select")
              .prop("selectedIndex", 0);
          } else {
            $("#edit-group-duration-work").show();
          }
        })
        .triggerHandler("loadtime");

      $(".field--name-field-disability")
        .on("change loadtime", function () {
          if ($(this).find("input:checked").val() == 1) {
            $(".field--name-field-percentage-of-disability").addClass("open");
          } else {
            $(".field--name-field-percentage-of-disability")
              .removeClass("open")
              .find("input")
              .val("");
          }
        })
        .triggerHandler("loadtime");

      $(".field--name-field-eu-driving-license")
        .on("change loadtime", function () {
          if ($(this).find("input:checked").val() == 1) {
            $(".field--name-field-specify-driving-license").addClass("open");
          } else {
            $(".field--name-field-specify-driving-license")
              .removeClass("open")
              .find("select")
              .prop("selectedIndex", 0);
          }
        })
        .triggerHandler("loadtime");


      // "Please provide details" is asked only about a training that is not
      // free for refugees, i.e. only once "No" is answered. Scoped to the node
      // form, because the same field is printed on the training offer page too.
      $(".node-form").each(function () {
        var this_form = this;
        var $details = $(".field--name-field-not-free-details", this_form);

        $(
          once(
            "training-free-conditional",
            ".field--name-field-free-training",
            this_form
          )
        )
          .on("change loadtime", function () {
            var free = $(this).find("input:checked").val();
            $details.toggleClass("open", free == 0);
          })
          .triggerHandler("loadtime");
      });

      // "I have completed this level" drives the rest of the degree row:
      // Yes -> start and end date. No -> the extra "I am still studying"
      // question shows up, and answering Yes there leaves only the start date,
      // answering No adds the number of years of the course completed. Scoped
      // per paragraph so several degrees on the same form stay independent of
      // each other.
      $(".paragraph-type--degree-and-qualification").each(function () {
        var this_paragraph = this;
        var $completed = $(
          ".field--name-field-certificate-obtained",
          this_paragraph
        );
        var $studying = $(".field--name-field-still-studying", this_paragraph);
        var $end_date = $(".field--name-field-end-date", this_paragraph);
        var $years = $(
          ".field--name-field-years-of-course-completed",
          this_paragraph
        );

        function refresh_degree_dates(reset) {
          var completed = $completed.find("input:checked").val();
          var studying = $studying.find("input:checked").val();
          var ask_studying = completed == 0;
          // The end date is meaningless only while the studies are ongoing.
          var hide_end_date = ask_studying && studying == 1;
          // How many years of the course were completed is asked only for a
          // course that was left unfinished.
          var ask_years = ask_studying && studying == 0;

          $studying.toggleClass("open", ask_studying);
          $end_date.toggleClass("closed", hide_end_date);
          $years.toggleClass("open", ask_years);

          // Clear hidden values only when the user changes an answer, so
          // opening an existing CV never wipes stored dates on page load.
          if (reset && !ask_studying) {
            $studying
              .find("input[type='radio']")
              .prop("checked", false)
              .filter("[value='_none']")
              .prop("checked", true);
          }
          if (reset && hide_end_date) {
            $end_date.find("select").prop("selectedIndex", 0);
          }
          if (reset && !ask_years) {
            $years.find("select").prop("selectedIndex", 0);
          }
        }

        $(
          once(
            "degree-conditional",
            ".field--name-field-certificate-obtained, .field--name-field-still-studying",
            this_paragraph
          )
        )
          .on("change loadtime", function (event) {
            refresh_degree_dates(event.type === "change");
          })
          .triggerHandler("loadtime");
      });

      $(".field--name-field-degree-diploma")
        .on("change loadtime", function () {
          if (
            $.inArray($(this).find("select option:selected").val(), [
              "5404",
              "5405",
              "5406",
            ]) !== -1
          ) {
            $(".field--name-field-area-of-study").addClass("open");
          } else {
            $(".field--name-field-area-of-study").removeClass("open");
          }
        })
        .triggerHandler("loadtime");

      $(".paragraph-type--work-experience").each(function () {
        var this_paragraph = this;
          $(once('clicked', ".field--name-field-current-experience", this_paragraph))
          .on("change loadtime", function () {

            if ($(this).find("input:checked").val() == 1) {
              $(".field--name-field-end-date", this_paragraph).addClass(
                "closed"
              );
            } else {
              $(".field--name-field-end-date", this_paragraph).removeClass(
                "closed"
              );
            }
          })
          .triggerHandler("loadtime");
      });
    },
  };

  Drupal.behaviors.LinkButtonRequired = {
    attach: function (context, settings) {
      $("article").each(function () {
        var $this_article = $(this);
        var requiredCheckboxes = $(this).find(
          "input[type='checkbox'].required"
        );

        if (requiredCheckboxes.length > 0) {
          $(this).find(".conditional-button").addClass("disabled");
          var totalRequired = requiredCheckboxes.length;
          var checkedCount = $(this).find(
            "input[type='checkbox'].required:checked"
          ).length;

          if (checkedCount === totalRequired) {
            $this_article
              .find(".conditional-button")
              .removeClass("disabled");
          } else {
            $this_article
              .find(".conditional-button")
              .addClass("disabled");
          }

          requiredCheckboxes.each(function () {
            $(this)
              .off()
              .on("change", function () {
                if ($(this).is(":checked")) {
                  checkedCount++;
                } else {
                  checkedCount--;
                }
                if (checkedCount === totalRequired) {
                  $(this)
                    .parents("article")
                    .find(".conditional-button")
                    .removeClass("disabled");
                } else {
                  $(this)
                    .parents("article")
                    .find(".conditional-button")
                    .addClass("disabled");
                }
              });
          });
        }
      });
    },
  };

  Drupal.behaviors.FormRequired = {
    attach: function (context, settings) {
      $("form").each(function () {
        var $this_form = $(this);
        var requiredCheckboxes = $(this).find(
          "input[type='checkbox'].required"
        );

        if (requiredCheckboxes.length > 0) {
          $(this).find(".form-submit").addClass("disabled");
          var totalRequired = requiredCheckboxes.length;
          var checkedCount = $(this).find(
            "input[type='checkbox'].required:checked"
          ).length;

          if (checkedCount === totalRequired) {
            $this_form
              .find(".form-submit")
              .removeClass("disabled");
          } else {
            $this_form
              .find(".form-submit")
              .addClass("disabled");
          }


          requiredCheckboxes.each(function () {
            $(this)
              .off()
              .on("change", function () {
                if ($(this).is(":checked")) {
                  checkedCount++;
                } else {
                  checkedCount--;
                }
                if (checkedCount === totalRequired) {
                  $(this)
                    .parents("form")
                    .find(".form-submit")
                    .removeClass("disabled");
                } else {
                  $(this)
                    .parents("form")
                    .find(".form-submit")
                    .addClass("disabled");
                }
              });
          });
        }
      });
    },
  };

  Drupal.behaviors.TerritorialFirstStep = {
    attach: function (context, settings) {
        $(once('form-open', ".selection-buttons .button-yes"))
        .on("click", function () {
          $(this).parents("form").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.Scroll = {
    attach: function (context, settings) {
        $(window).on("scroll", function () {
          if ($(window).scrollTop() > 0) {
            $("body").addClass("scrolled");
          } else {
            $("body").removeClass("scrolled");
          }
        });
    },
  };

  Drupal.behaviors.hs = {
    attach: function (context, settings) {
      $(once("bef-asd",".bef-checkboxes.bef-nested li"))
        .each(function () {
          if ($(this).children("ul").length) {
            $(this)
              .addClass("parent-li")
              .prepend('<span class="toggle-button">+</span>');
          }
        });
        $(once("asdas123d",".bef-checkboxes.bef-nested li .toggle-button"))
        .on("click", function () {
          $(this).parent("li").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.validation = {
    attach: function (context, settings) {
      $(once('rkpt',".node-candidate-profile-form, .node-company-profile-form, .node-territorial-profile-form, .node-training-agency-profile-form"))
        .attr("novalidate", "novalidate")
        .each(function () {
          $("#edit-submit.form-submit", this).on("click", function (event) {
            event.preventDefault();

            var FromDay = $('#edit-field-work-experience-0-subform-field-start-date-0-value-day');
            var FromMonth = $('#edit-field-work-experience-0-subform-field-start-date-0-value-month');
            var FromYear = $('#edit-field-work-experience-0-subform-field-start-date-0-value-year');

            if (FromYear.val()) {
              if (!FromDay.val()) {
                FromDay.val('1');
              }
              if (!FromMonth.val()) {
                FromMonth.val('1');
              }
            }

            var ToDay = $('#edit-field-work-experience-0-subform-field-end-date-0-value-day');
            var ToMonth = $('#edit-field-work-experience-0-subform-field-end-date-0-value-month');
            var ToYear = $('#edit-field-work-experience-0-subform-field-end-date-0-value-year');

            if (ToYear.val()) {
              if (!ToDay.val()) {
                ToDay.val('1');
              }
              if (!ToMonth.val()) {
                ToMonth.val('1');
              }
            }


            $(".form-text[required=required]").each(function () {
              if (!$(this).val()) {
                $(this).addClass("stam_error");
                $(this).parents("fieldset").addClass("open");
              } else {
                $(this).removeClass("stam_error");
              }
            });

            // The per-level selects of a client-side hierarchical select (cshs)
            // are excluded here: they are generated by the cshs plugin, which
            // copies the class list of the root select onto each of them, so
            // their "required" class says nothing about their requiredness.
            // They are validated as a single field right below.
            $(".form-select.required:not(.simpler-select-root):not(.simpler-select)").each(function () {
              if (isEmptySelection($(this).val())) {
                $(this).addClass("stam_error");
                $(this).parents("fieldset").addClass("open");
              } else {
                $(this).removeClass("stam_error");
              }
            });

            // Client-side hierarchical selects. The real value and the real
            // "required" state live on the hidden root select; the visible
            // selects are one per hierarchy level. Stopping at a parent level
            // is a valid answer unless the widget is configured to force the
            // deepest level (or a required depth) - both are exposed as data
            // attributes on the root select by rkpt_general.
            $("select.simpler-select-root").each(function () {
              var $root = $(this);
              var $levels = $root.nextAll(".select-wrapper").find("select.simpler-select");

              $levels.removeClass("stam_error");

              if (!$root.is("[required]") && !$root.hasClass("required")) {
                return;
              }

              var value = $root.val();

              // With the "Save lineage" setting the root holds the whole
              // lineage, the deepest selection being the last one.
              if (value instanceof Array) {
                value = value.length ? value[value.length - 1] : null;
              }

              var $invalid = $();

              if (isEmptySelection(value)) {
                // Nothing selected at all: point at the first level.
                $invalid = $levels.first();
              } else if ($root.data("cshs-force-deepest")) {
                // A next level is rendered only while the current selection
                // has children, so an unanswered last level means the user
                // stopped on a parent term.
                if (isEmptySelection($levels.last().val())) {
                  $invalid = $levels.last();
                }
              } else {
                var requiredDepth = parseInt($root.data("cshs-required-depth"), 10) || 0;
                var answered = $levels.filter(function () {
                  return !isEmptySelection($(this).val());
                }).length;

                if (answered < requiredDepth) {
                  $invalid = $levels.eq(answered).length ? $levels.eq(answered) : $levels.last();
                }
              }

              if ($invalid.length) {
                $invalid.addClass("stam_error");
                $invalid.parents("fieldset").addClass("open");
              }
            });

            $(".form-email.required").each(function () {
              if (!isEmail($(this).val())) {
                $(this).addClass("stam_error");
                $(this).parents("fieldset").addClass("open");
              } else {
                $(this).removeClass("stam_error");
              }
            });

            $(".field--type-file").each(function () {
              if ($("label", this).hasClass("form-required")) {
                $(".form-file", this).addClass("stam_error");
                $(".form-file", this).parents("fieldset").addClass("open");
              } else {
                $(".form-file", this).removeClass("stam_error");
              }
            });

            if ($(".stam_error").length) {
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $(".stam_error").offset().top - $("header").height() - 30,
                },
                600
              );
            } else {
              $(this).unbind("click").click();
            }
          });
        });
      function isEmail(email) {
        var regex =
          /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      }
      // The "nothing selected" markers used by Drupal ("_none") and by the
      // cshs element ("All", its `#none_value`).
      function isEmptySelection(value) {
        return value === null || value === undefined || $.inArray(value, ["", "All", "_none"]) !== -1;
      }
    },
  };

  Drupal.behaviors.ExternalLinks = {
    attach: function (context, settings) {
      if (
        $(".paragraph--type--title-text-img.full-image.with-bg-image").length
      ) {
        $(".paragraph--type--title-text-img.full-image.with-bg-image").each(
          function () {
            var textHeight = $(this).find(".title-text-banner").height();

            $(this)
              .find(".field-background-image img")
              .css("min-height", textHeight);
          }
        );
      }
    },
  };

  Drupal.behaviors.BgImage = {
    attach: function (context, settings) {
      $("a").each(function () {
        if ($(this).attr("type") == "application/pdf") {
          $(this).attr("target", "_blank");
        }
      });
    },
  };

  Drupal.behaviors.Accordion = {
    attach: function (context, settings) {
      $(once("pai-open",".paragraph-accordion-item > .field-title"))
        .on("click", function () {
          $(this).parent(".paragraph-accordion-item").toggleClass("open");
        });
    },
  };

  Drupal.behaviors.WorkExperienceAccordion = {
    attach: function (context, settings) {
      $(once("we-accordion", ".paragraph-type--work-experience", context)).each(
        function (index) {
          var $item = $(this);
          var $subform = $item.find(".paragraphs-subform").first();
          var $header = $(
            '<div class="work-experience-accordion__header"><span class="work-experience-accordion__title"></span></div>'
          );
          var $title = $header.find(".work-experience-accordion__title");

          function summaryLabel() {
            var role = $.trim(
              $item.find(".field--name-field-job-role input").val() || ""
            );
            var company = $.trim(
              $item
                .find(".field--name-field-work-experience-company input")
                .val() || ""
            );
            var label = Drupal.t("Work Experience #@number", {
              "@number": index + 1,
            });
            var details = [role, company].filter(Boolean).join(" @ ");
            return details ? label + ": " + details : label;
          }

          $title.text(summaryLabel());
          $item.addClass("work-experience-accordion open");
          $header.insertBefore($item.find(".paragraph-top").first());

          $item
            .find(
              ".field--name-field-job-role input, .field--name-field-work-experience-company input"
            )
            .on("keyup change", function () {
              $title.text(summaryLabel());
            });

          $header.on("click", function () {
            $item.toggleClass("open");
          });
        }
      );
    },
  };

  // Relocates each paragraph item's "Remove" button (buried in the top
  // actions dropdown, alongside Duplicate/Convert when those are enabled)
  // to the bottom of the entry, above the divider, so it's reachable
  // without opening the dropdown. Shared across every paragraph field we
  // want this treatment on; add an entry to `configs` for more fields.
  Drupal.behaviors.ParagraphsBottomRemoveButton = {
    attach: function (context, settings) {
      var configs = [
        {
          selector: ".paragraph-type--work-experience",
          once: "we-remove-button",
          label: Drupal.t("Remove Work Experience"),
        },
        {
          selector: ".paragraph-type--degree-and-qualification",
          once: "degree-remove-button",
          label: Drupal.t("Remove Education"),
        },
        {
          selector: ".paragraph-type--professional-courses",
          once: "professional-courses-remove-button",
          label: Drupal.t("Remove Professional Course"),
        },
        {
          selector: ".paragraph-type--language",
          once: "language-remove-button",
          label: Drupal.t("Remove Language"),
        },
      ];

      configs.forEach(function (config) {
        $(once(config.once, config.selector, context)).each(function () {
          var $item = $(this);
          var $subform = $item.find(".paragraphs-subform").first();
          var $removeButton = $item
            .find('.paragraphs-dropdown-actions [id$="-remove"]')
            .first();

          if (!$subform.length || !$removeButton.length) {
            return;
          }

          var $dropdownActions = $removeButton.closest(
            ".paragraphs-dropdown-actions"
          );

          $removeButton.val(config.label).addClass("paragraphs-remove-button");
          $('<div class="paragraphs-remove-button-wrap"></div>')
            .append($removeButton)
            .insertAfter($subform);

          // Only hide the dropdown toggle if nothing else (e.g. Duplicate)
          // is left in it.
          if ($dropdownActions.children().length === 0) {
            $dropdownActions.closest(".paragraphs-dropdown").hide();
          }
        });
      });
    },
  };

  Drupal.behaviors.Swiper = {
    attach: function (context, settings) {
      if ($(".swiper-logos").length) {
        let logosSwipers = document.querySelectorAll(".swiper-logos");
        let prevArrow = document.querySelectorAll(".logos-swiper-button-prev");
        let nextArrow = document.querySelectorAll(".logos-swiper-button-next");
        logosSwipers.forEach((slider, index) => {
          const uspSwiper = new Swiper(slider, {
            arrows: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
              nextEl: nextArrow[index],
              prevEl: prevArrow[index],
            },
          });
        });
      }

      if ($(".swiper-title-with-usp").length) {
        let uspSwipers = document.querySelectorAll(".swiper-title-with-usp");
        let prevArrow = document.querySelectorAll(".usp-swiper-button-prev");
        let nextArrow = document.querySelectorAll(".usp-swiper-button-next");

        uspSwipers.forEach((slider, index) => {
          const uspSwiper = new Swiper(slider, {
            arrows: true,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
              nextEl: nextArrow[index],
              prevEl: prevArrow[index],
            },
            breakpoints: {
              600: {
                slidesPerView: 2,
              },
              900: {
                slidesPerView: 3,
              },
            },
          });
        });
      }
    },
  };

  // Supporters logos slideshow: horizontal Swiper carousel that autoplays and
  // has prev/next buttons. Reuses the view's own markup as the swiper wrapper
  // and slides via wrapperClass/slideClass.
  Drupal.behaviors.supportersSlideshow = {
    attach: function (context, settings) {
      once(
        "supporters-slideshow",
        ".view-supporters.view-display-supporters_slideshow",
        context
      ).forEach(function (el) {
        var wrap = el.closest(".supporters-slideshow") || el.parentNode;
        new Swiper(el, {
          wrapperClass: "view-content",
          slideClass: "views-row",
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 20,
          loop: true,
          speed: 600,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            prevEl: wrap.querySelector(".supporters-nav-prev"),
            nextEl: wrap.querySelector(".supporters-nav-next"),
          },
          breakpoints: {
            600: {
              slidesPerView: 3,
            },
            900: {
              slidesPerView: 5,
            },
          },
        });
      });
    },
  };

  Drupal.behaviors.passwordVisibility = {
    attach: function (context, settings) {
      $(".js-form-type-password").each(function () {
        $(this).append('<span class="pw-visibility"></span>');

        $(document).on("click", ".pw-visibility", function () {
          $(this)
            .parent(".js-form-type-password")
            .toggleClass("visible")
            .find("input")
            .attr("type", function (index, attr) {
              return attr == "password" ? "text" : "password";
            });
        });
      });
    },
  };


    Drupal.behaviors.AutocompleteRemoveId = {
      attach: function (context, settings) {
        $(once("autocomplete_remove_id","body .ui-autocomplete-input", context))
          .each(function () {
            var $autocompleteField = $(this);
            var selectedValue = $autocompleteField.val();
            var modifiedValue = selectedValue
              .replace(/ *\([^)]*\) */g, "")
              .replace(/\"/g, "");
            $autocompleteField.val(modifiedValue);

            $autocompleteField.on("autocompleteclose", function (event, ui) {
              var selectedValue = $autocompleteField.val();
              var modifiedValue = selectedValue
                .replace(/ *\([^)]*\) */g, "")
                .replace(/\"/g, "");
              $autocompleteField.val(modifiedValue);
            });
          });
      },
    };

    Drupal.behaviors.contactSelection = {
      attach: function (context, settings) {
        const contact_forms_relation = [];
        contact_forms_relation["company-webform"] =
          "webform-submission-company-contact-form";
        contact_forms_relation["candidate-webform"] =
          "webform-submission-refugee-contact-form";
        contact_forms_relation["wn-webform"] =
          "webform-submission-welcomenet-contact-form";
        contact_forms_relation["general-webform"] =
          "webform-submission-contact-form";

        $(once("clicked",".contact_selection .tab"))
          .on("click", function () {
            $(".active").removeClass("active");
            $(this).addClass("active");
            $(".block-rkpt-general-contact-forms form.open").removeClass("open");
            $("." + contact_forms_relation[$(this).attr("id")]).addClass(
              "open"
            );
          });
      },
    };

Drupal.behaviors.addCompanyProfileBodyDescription = {
      attach: function (context, settings) {
        const currentLanguage = drupalSettings.path.currentLanguage;
        const BodyDesc = `The brief description of the company will be included in the job postings.`;
        if (currentLanguage == 'it') {
          BodyDesc = `La descrizione sintetica dell'azienda verrà riportata all'interno degli annunci di lavoro pubblicati`;
        }
        $(once('body-desc','#node-company-profile-form #edit-body-wrapper .form-item-body-0-value label')).after('<div class="description">' + BodyDesc + '</div>');
      },
    };

    Drupal.behaviors.addLocationDescription = {
      attach: function (context, settings) {
        $('#edit-field-job-desired-occupation-wrapper .description', context).insertAfter('#edit-field-job-desired-occupation-wrapper .field-multiple-table .field-label')
      },
    };

    // News /all page: toggle the hidden tags with the More/Less button.
    Drupal.behaviors.newsTagsMore = {
      attach: function (context, settings) {
        $(once('news-tags-more', '.news-tags-more', context))
          .on('click', function () {
            var expanded = $(this)
              .closest('.news-tags-wrapper')
              .toggleClass('is-expanded')
              .hasClass('is-expanded');
            $(this).text(expanded ? Drupal.t('Less') : Drupal.t('More'));
          });
      },
    };


})(jQuery, Drupal, drupalSettings);
